import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.VITE_APP_ENV === 'production',
  environment: import.meta.env.VITE_APP_ENV ?? 'development',

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // Masquer les champs sensibles dans les replays
      maskAllInputs: true,
      blockAllMedia: false,
    }),
  ],

  tracesSampleRate: 0.2,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/api\.coliseco\.com/,
  ],

  // Session Replay : 10 % des sessions, 100 % sur erreur
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
